export type VillaShareTarget = {
  href: string;
  icon: "whatsapp" | "telegram" | "x" | "email" | "sms" | "bale";
  label: string;
  openInNewTab: boolean;
};

export const getVillaShareTargets = (
  title: string,
  shareUrl: string
): Array<VillaShareTarget> => {
  const encodedTitle = encodeURIComponent(title);
  const encodedUrl = encodeURIComponent(shareUrl);
  const encodedMessage = encodeURIComponent(`${title}\n${shareUrl}`);

  return [
    {
      href: `https://wa.me/?text=${encodedMessage}`,
      icon: "whatsapp",
      label: "واتساپ",
      openInNewTab: true
    },
    {
      href: `https://t.me/share/url?url=${encodedUrl}&text=${encodedTitle}`,
      icon: "telegram",
      label: "تلگرام",
      openInNewTab: true
    },
    {
      href: `https://x.com/intent/post?url=${encodedUrl}&text=${encodedTitle}`,
      icon: "x",
      label: "ایکس",
      openInNewTab: true
    },
    {
      href: `https://ble.ir/share/url?url=${encodedUrl}&text=${encodedTitle}`,
      icon: "bale",
      label: "بله",
      openInNewTab: true
    },
    {
      href: `sms:?body=${encodedMessage}`,
      icon: "sms",
      label: "پیامک",
      openInNewTab: false
    }
  ];
};
